// Vanilla-JS port of the source app's <Product3DCard> component: pointer-tilt on hover,
// a continuous idle/spin CSS keyframe animation (paused off-screen or on hover), and
// touch-drag rotation on mobile. Markup comes from snippets/product-3d-card.liquid.
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(wrapper) {
    var card = wrapper.querySelector('.tap-3d-card__inner');
    if (!card) return;
    var spin = wrapper.getAttribute('data-spin') === 'true';
    var isVisible = true;
    var isHovering = false;
    var dragState = { dragging: false, startX: 0, rotY: spin ? 0 : -10 };

    if (prefersReduced) {
      card.style.transform = spin
        ? 'rotateX(35deg) rotateY(-20deg)'
        : 'rotateX(5deg) rotateY(-10deg)';
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          isVisible = entries[0].isIntersecting;
          if (!isHovering) {
            card.style.animationPlayState = isVisible ? 'running' : 'paused';
          }
        },
        { threshold: 0 }
      );
      observer.observe(wrapper);
    }

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      var raf = null;
      wrapper.addEventListener('pointermove', function (e) {
        var rect = wrapper.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform = spin
            ? 'rotateX(35deg) rotateY(' + (x * 40).toFixed(2) + 'deg) translateY(-4px)'
            : 'rotateX(' + (-y * 14 + 6).toFixed(2) + 'deg) rotateY(' + (x * 18 - 10).toFixed(2) + 'deg) translateY(-4px)';
        });
      });
      wrapper.addEventListener('pointerenter', function () {
        isHovering = true;
        card.style.animationPlayState = 'paused';
      });
      wrapper.addEventListener('pointerleave', function () {
        isHovering = false;
        card.style.transform = '';
        card.style.animationPlayState = isVisible ? 'running' : 'paused';
      });
    }

    card.addEventListener(
      'touchstart',
      function (e) {
        dragState.dragging = true;
        dragState.startX = e.touches[0].clientX;
        card.style.animationPlayState = 'paused';
      },
      { passive: true }
    );
    card.addEventListener(
      'touchmove',
      function (e) {
        if (!dragState.dragging) return;
        var delta = e.touches[0].clientX - dragState.startX;
        var rotY = dragState.rotY + delta / 6;
        card.style.transform = spin ? 'rotateX(35deg) rotateY(' + rotY + 'deg)' : 'rotateX(6deg) rotateY(' + rotY + 'deg)';
      },
      { passive: true }
    );
    card.addEventListener('touchend', function (e) {
      if (!dragState.dragging) return;
      var lastTouch = e.changedTouches[0];
      var delta = (lastTouch ? lastTouch.clientX : 0) - dragState.startX;
      dragState.rotY += delta / 6;
      dragState.dragging = false;
      window.setTimeout(function () {
        card.style.transform = '';
        card.style.animationPlayState = !isVisible ? 'paused' : 'running';
      }, 400);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.tap-3d-card').forEach(setup);
  });
})();
